module.exports = __webpack_public_path__ + "img/delivery-bg-sm.eab497bf.jpg";